document.querySelectorAll('.np-page-informator .informator').forEach((title, index) => {
  const content = title.nextElementSibling;
  const level = title.classList.contains('informator-level2-title') ? 2 : 1;
  if (!content?.classList.contains(`informator-level${level}-content`)) return;

  const titleId = `np-informator-title-${index + 1}`;
  const contentId = `np-informator-panel-${index + 1}`;
  title.id = titleId;
  title.tabIndex = 0;
  title.setAttribute('role', 'button');
  title.setAttribute('aria-expanded', 'false');
  title.setAttribute('aria-controls', contentId);
  content.id = contentId;
  content.hidden = true;
  content.setAttribute('role', 'region');
  content.setAttribute('aria-labelledby', titleId);

  const toggle = () => {
    const open = title.getAttribute('aria-expanded') !== 'true';
    title.setAttribute('aria-expanded', String(open));
    title.classList.toggle('informatoropened', open);
    content.hidden = !open;
  };
  title.addEventListener('click', toggle);
  title.addEventListener('keydown', (event) => {
    if (!['Enter', ' '].includes(event.key)) return;
    event.preventDefault();
    toggle();
  });
});
